module.exports = __webpack_public_path__ + "assets/internal-hero-bg.f7232817.svg";